<template>
	<div>
		<div class="row">
			<div class="col-md-12 mb-2">
				<h4>LPG REPORT</h4>
			</div>

			<div class="col-md-12 mb-3">
				<el-row class="scrollable-row">
					<el-button :type="tabIndex == index ? 'primary' : 'plain'" class="" size="medium" v-for="(item, index) in tabList" :key="'btn-tab-'+index" @click="selectTab(index)"> <i class="fa fa-angle-down"></i> &nbsp; {{ item.label }}</el-button>
				</el-row>
			</div>

			<div class="col-md-12 mb-2">
				<el-card shadow="never" class="box-card col-md-12 mb-0" :body-style="{ paddingLeft: '6px', paddingRight: '6px', paddingTop: '10px', paddingBottom: '16px' }">
					<div> 
						<div v-for="(item, index) in tabList" :label="item.label" :name="item.index" :key="index" >
							<LPGReportTab v-show="tabIndex == index" :tabIndex="item.index" :tabName="item.name" :tabLabel="item.label" :showTitle="true"/>
						</div>
					</div>
				</el-card>	
			</div>

			<div class="col-md-12" v-if="false">
				<el-card class="box-card col-md-12 mb-4" :body-style="{ paddingLeft: '0px', paddingRight: '0px' }">
					<div slot="header" class="clearfix">
						<span><strong>LPG REPORT</strong></span>
					</div>
					<div>
						<div class="mb-3" style="margin-top:-21px;">   
							<el-tabs type="border-card" v-model="tabIndex" @tab-click="handleTabClick">
								<el-tab-pane :label="item.label" :name="item.index" v-for="(item, index) in tabList" :key="index" >
									<LPGReportTab :tabIndex="item.index" :tabName="item.name" :tabLabel="item.label"/>
								</el-tab-pane>
							</el-tabs>
						</div>
					</div>
				</el-card>	
			</div>
		</div>
	</div>
</template>

<script>

import LPG from '@/components/page/LPG.js'
import LPGReportTab from '@/views/pages/LPGReportTab.vue'

export default
{
	extends: LPG,
	components: { 
		LPGReportTab
		},

	data(){
		return {
			tabIndex: this.$route.query.tab ? this.$route.query.tab : '0', 
			tabList:[
				{label:'Sales LPG', name: 'sales_lpg', index: '0' },
				{label:'Sales Keagenan', name: 'sales_keagenan', index: '1' },
				{label:'Margin Keagenan', name: 'margin_keagenan', index: '2' },
			]
		}
	},
	watch:
	{
		//area() { this.resumePilihan() },
		//status(){ this.resumePilihan() },
	}, 
    mounted()
    {
        this.$emit('childrenRoute');
    },
    methods:{
		handleTabClick() {
			/*
            this.tab.index = tabIndex
            this.tab.name = tabName
            this.tab.label = tabLabel
			*/
        },

		selectTab(index) {
			this.tabIndex = `${index}`; //String(index);
			//console.log('index: ' + index);
		}

    }
}
</script>
<style>

.fade-enter-active, .fade-leave-active {
  opacity: 1;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}


</style>